(function () {
  'use strict';

  angular
  .module('neo.home.ajuntaments.newAjuntament')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.ajuntaments.newAjuntament', {
      url: '/new',
      templateUrl: 'home/ajuntaments/new-ajuntament/new-ajuntament.tpl.html',
      controller: 'NewAjuntamentCtrl',
      controllerAs: 'vm',
      resolve: {
        acl: function ($q, AclService) {
          if (AclService.can('TOWN_HALL', 'C')) {
            // Has proper permissions
            return true;
          } else {
            // Does not have permission
            return $q.reject('Unauthorized');
          }
        },
        towns: function (Poblacions) {
          return Poblacions.query().$promise;
        }
      }
    });
  }
}());
